<template>
  <span v-show="show" :class="styles">{{formatted}}</span>
</template>

<script>
export default {
  name: 'mv-amount',
  props: ['amount', 'inverse', 'hidenil'],
  computed: {
    formatted () {
      return (this.amount >= 0 ? '+' : '') + (parseFloat(this.amount) / 100).toFixed(2)
    },
    styles () {
      return 'mvamount' +
      (this.amount < 0 ? ' mvamount-minus' : ' mvamount-plus') +
      (this.inverse === '' ? ' mvamount-inverse' : '')
    },
    show () {
      return !(this.hidenil === '' && this.amount === 0)
    }
  }
}
</script>

<style lang="css">
.mvamount {
  display: inline-block;
  min-width: 35px;
  -font-size: 15px;
  font-family: 'Roboto Mono', monospace !important;
  font-weight: 500;
  text-align: center;
  padding: 3px;
}
.mvamount-minus {
  color: #ed5381;
}
.mvamount-plus {
  color: #5fb2e2;
}
.mvamount-minus.mvamount-inverse {
  background-color: #ed5381;
  color: white;
}
.mvamount-plus.mvamount-inverse {
  background-color: #5fb2e2;
  color: white;
}
</style>
